// This file is auto-generated, do not modify directly!

export const GetHealth = {
  endpoint: '/healthcheck',
  method: 'get'
};
export const GetUserPreference = {
  endpoint: '/user-preference/{key}',
  method: 'get'
};
export const SetUserPreference = {
  endpoint: '/user-preference/{key}',
  method: 'post'
};
export const DeleteUserPreference = {
  endpoint: '/user-preference/{key}',
  method: 'delete'
};